import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { IRootState } from '../../../../../../../redux/types'

interface IFilter {
  brandsL: any
  countriesL: any
  provinceL: any
  postalcodesL: any
  brandsR: any
  countriesR: any
  provinceR: any
  postalcodesR: any
  typeLink: number
}

export function useUserTransferFilters(tmpRows: any) {
  const { userProfileSelected } = useSelector((state: IRootState) => state.user)

  const [filters, setFilters] = useState<IFilter>({
    brandsL: [],
    countriesL: [],
    provinceL: [],
    postalcodesL: [],
    brandsR: [],
    countriesR: [],
    provinceR: [],
    postalcodesR: [],
    typeLink: 1
  })
  const [usersFiltered, setUsersFiltered] = useState({
    left: [],
    right: []
  })

  useEffect(() => {
    applyUsersFilter()
  }, [filters])

  useEffect(() => {
    applyUsersFilter()
  }, [tmpRows])

  const applyUsersFilter = async () => {
    let usersFilteredR: any = tmpRows.right.filter((row: any) => row.role_id !== userProfileSelected.role_id)
    let usersFilteredL: any = tmpRows.left.filter((row: any) => row.role_id !== userProfileSelected.role_id)

    // Left Side
    // Postalcodes Filter
    if (filters.postalcodesL.length > 0) {
      let postalcodesFilter: any = []
      await usersFilteredL.map((user: any) => {
        filters.postalcodesL.map((postalcode: any) => {
          if (user.postalcode === postalcode) postalcodesFilter.push(user)
        })
      })
      usersFilteredL = postalcodesFilter
    }

    // Province Filter
    if (filters.provinceL.id !== undefined) {
      let provinceFilter: any = []
      await usersFilteredL.map((user: any) => {
        if (user.province_id === filters.provinceL.id) {
          provinceFilter.push(user)
        }
      })
      usersFilteredL = provinceFilter
    }

    // Brands Filter
    if (filters.brandsL.length > 0) {
      let brandFilter: any = []
      await usersFilteredL.map((user: any) => {
        filters.brandsL.map((brand: any) => {
          if (user.brands_ids.split(',').includes(brand.toString())) brandFilter.push(user)
        })
      })
      usersFilteredL = brandFilter
    }

    // Countries Filter
    if (filters.countriesL.length > 0) {
      let countriesFilter: any = []
      await usersFilteredL.map((user: any) => {
        filters.countriesL.map((country: any) => {
          if (user.countries_ids.split(',').includes(country.toString())) countriesFilter.push(user)
        })
      })
      usersFilteredL = countriesFilter
    }

    // Right Side

    // Postalcodes Filter
    if (filters.postalcodesR.length > 0) {
      let postalcodesFilter: any = []
      await usersFilteredR.map((user: any) => {
        filters.postalcodesR.map((postalcode: any) => {
          if (user.postalcode === postalcode) postalcodesFilter.push(user)
        })
      })
      usersFilteredR = postalcodesFilter
    }

    // Province Filter
    if (filters.provinceR.id !== undefined) {
      let provinceFilter: any = []
      await usersFilteredR.map((user: any) => {
        if (user.province_id === filters.provinceR.id) {
          provinceFilter.push(user)
        }
      })
      usersFilteredR = provinceFilter
    }

    // Brands Filter
    if (filters.brandsR.length > 0) {
      let brandFilter: any = []
      await usersFilteredR.map((user: any) => {
        filters.brandsR.map((brand: any) => {
          if (user.brands_ids.split(',').includes(brand.toString())) brandFilter.push(user)
        })
      })
      usersFilteredR = brandFilter
    }

    // Countries Filter
    if (filters.countriesR.length > 0) {
      let countriesFilter: any = []
      await usersFilteredR.map((user: any) => {
        filters.countriesR.map((country: any) => {
          if (user.countries_ids.split(',').includes(country.toString())) countriesFilter.push(user)
        })
      })
      usersFilteredR = countriesFilter
    }

    setUsersFiltered({ ...usersFiltered, right: usersFilteredR, left: usersFilteredL })
  }

  return { filters, setFilters, usersFiltered }
}
